@if (filtersForm() && this.controlName()) {
  <vectronic-filter-header
    (titleClicked)="toggleShowFilter()"
    title="{{ title() }}"
    [svgIcon]="svgIcon()"
    [icon]="icon()"
    (enabledFilterToggle)="toggleShowFilter()"
    [isFilterEnabled]="isFilterHidden()"
  ></vectronic-filter-header>

  <div
    [hidden]="!isFilterHidden()"
    [formGroup]="filtersForm()"
    (click)="filtersForm().get(filterEnableControl()).setValue(true)"
  >
    <div class="animal-name-filter filter-body">
      <mat-form-field
        class="animal-name-filter__form-field"
        id="animal-name-form"
        appearance="outline"
      >
        <mat-label>Device ID</mat-label>
        <input
          matInput
          #input
          [formControlName]="controlName()"
          [value]="filtersForm().get(controlName()).value"
        />
      </mat-form-field>
    </div>
  </div>
}
